module.exports = __webpack_public_path__ + "static/editing-f043c6e7df4f3c6c47671f79fc2fa4c3.png";